import { useQuery } from '@tanstack/react-query';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { getCurrentGatewayUrl } from '../../utils/environmentDetection';
import { getAuthHeaders } from '../../utils/authHeaders';

export function useApplicationRoles({
  applicationId,
  tenantId,
}: {
  applicationId?: string;
  tenantId?: string;
}) {
  return useQuery({
    queryKey: ['application-roles', applicationId],
    queryFn: async () => {
      if (!applicationId || !tenantId) {
        return { roles: [] };
      }

      const authHeaders = await getAuthHeaders();
      const response = await applicationsClient.getRoles({
        params: { id: applicationId },
        overrideClientOptions: {
          baseUrl: `${getCurrentGatewayUrl()}/orchestrator`,
        },
        extraHeaders: {
          ...authHeaders,
        },
      });

      if (response.status === 200) {
        return response.body;
      }

      throw new Error('Failed to fetch roles');
    },
    enabled: !!applicationId && !!tenantId,
    refetchOnWindowFocus: false,
  });
}
